<ng-container *ngIf="!isGridsterInMobileMode" [ngTemplateOutlet]="standardView"></ng-container>
<ng-container *ngIf="isGridsterInMobileMode" [ngTemplateOutlet]="miniModeView"></ng-container>

<ng-template #miniModeView>
    <toro-dashboard-widget-container
            [title]="title"
            [titleIcon]="titleIcon"
            [isBusy]="isBusy"
            [lastUpdated]="lastUpdated"
            [associatedWidget]="associatedWidget"
            [widgetMenuItems]="widgetMenuItems"
            [analyticsWidgetName]="analyticsWidgetName"
            [(alertText)]="alertText"
            [(isUnableToFetchData)]="isUnableToFetchData"
            [unableToFetchDataReason]="unableToFetchDataReason"
            [showEmptyFooter]="isGridsterInMobileMode"
            [showLinkButton]="true"
            (gotoSite)="onMyTurfLinkClick();"
    >

        <div class="toro-my-turf-maintenance-widget-content mini-mode-widget-container">

            <div class="toro-widget-content-pane toro-component-shield-host">
                <div class="toro-mini-mode-content-panel">
                    <div id="tmm-mt-course-info" class="toro-mini-mode-content">
                        <i class="tmm-ul-icon toro-id-maintenance"></i>
                        <div class="tmm-bot-left-container">
                            <div>{{'SPECIAL_MSG.ASSETS_UNDER_REPAIR_OR_MAINTENANCE_FOR_ALL' | translate}}</div>
                        </div>
                    </div>
                </div>
                <div id="tmm-mt-dm-value-container" class="toro-mini-mode-content-panel ">
                    <div id="tmm-mt-metric-container" class="toro-mini-mode-content">
                        <div class="tmm-large-value">{{assets?.length || '0'}}</div>
                    </div>
                </div>
                <toro-component-shield (shieldClick)="onLaunchModalWidget()"></toro-component-shield>
            </div>

        </div>

    </toro-dashboard-widget-container>
</ng-template>

<ng-template #standardView>
    <toro-dashboard-widget-container
            [title]="title"
            [titleIcon]="titleIcon"
            [isBusy]="isBusy"
            [lastUpdated]="lastUpdated"
            [associatedWidget]="associatedWidget"
            [widgetMenuItems]="widgetMenuItems"
            [analyticsWidgetName]="analyticsWidgetName"
            [(alertText)]="alertText"
            [(isUnableToFetchData)]="isUnableToFetchData"
            [unableToFetchDataReason]="unableToFetchDataReason"
    >

        <div class="toro-my-turf-maintenance-widget-content toro-flex-child toro-link-button-host toro-component-shield-host">
            <toro-widget-link-button (click)="onMyTurfLinkClick()" imageSrc="../../../../../assets/images/myTurfIcon.png"></toro-widget-link-button>
            <div *ngIf="myTurfUserName != null" class="tmt-account-info">
                <span class="tmt-account-label">{{'STRINGS.MY_TURF_ACCOUNT' | translate}}</span>
                <span class="tmt-account-name">{{myTurfUserName}}</span>
            </div>

            <div id="tmym-top-pane">
                <div id="tmym-icon-pane">
                    <i class="tmm-ul-icon toro-id-maintenance"></i>
                </div>
                <div id="tmym-count-pane">{{assets?.length || '0'}}</div>
            </div>
            <div id="tmym-bottom-pane" [ngClass]="language">
                <div>{{'STRINGS.ASSETS_UNDER_REPAIR_OR_MAINTENANCE' | translate }}</div>
                <div>{{'STRINGS.FOR_ALL_LOCATIONS' | translate | lowercase}}</div>
            </div>

            <toro-component-shield></toro-component-shield>
        </div>

        <div class="mt-bottom-toolbar-container" [ngClass]="language">
            <toro-widget-button
                    [text]="'STRINGS.VIEW_ASSETS' | translate | titlecase"
                    [disabled]="!assets || assets?.length < 1"
                    (buttonClick)="showAssets()"
            ></toro-widget-button>
        </div>
    </toro-dashboard-widget-container>
</ng-template>

<ng-template #titleIcon>
    <fa-icon icon="square" [ngStyle]="{'color': iconColor}"></fa-icon>
</ng-template>

<toro-my-turf-details-dlg *ngIf="showDetailsDialog" [title]="title" [subtitle]="subtitle" [recordCount]="assets?.length" (cancel)="showDetailsDialog = false;">

    <div id="my-turf-details-table-container" class="toro-flex-child">
        <p-table [value]="assets" [scrollable]="true" scrollHeight="flex" [resizableColumns]="true">
            <ng-template pTemplate="colgroup">
                <colgroup>
                    <col style="width:30%">
                    <col style="width:70%">
                </colgroup>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th [pSortableColumn]="'assetCode'" pResizableColumn>{{'STRINGS.ASSET_ID' | translate | titlecase}}
                        <p-sortIcon [field]="'assetCode'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'description'" pResizableColumn>{{'STRINGS.DESCRIPTION' | translate | titlecase}}
                        <p-sortIcon [field]="'description'"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-asset>
                <tr>
                    <td>{{asset.assetCode}}</td>
                    <td>{{asset.description}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>

</toro-my-turf-details-dlg>

<toro-mini-mode-widget-modal *ngIf="showMiniModeModal" (cancel)="showMiniModeModal = false">
    <div id="mini-mode-modal-content-container" [ngStyle]="{'height': WidgetSingleRowHeight + 'px'}">
        <ng-container [ngTemplateOutlet]="standardView"></ng-container>
    </div>
</toro-mini-mode-widget-modal>
